/* 🤖 this file was generated by script */
export const wiconAlertTriangle = {
  name: 'alert_triangle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v4m0 4h.01m-1.4-13.1L2.4 18.1c-.46.79-.68 1.18-.65 1.5a1 1 0 00.4.7c.27.2.72.2 1.63.2h16.45c.92 0 1.37 0 1.63-.2a1 1 0 00.41-.7c.03-.32-.2-.71-.65-1.5L13.38 3.9c-.45-.8-.68-1.19-.97-1.32a1 1 0 00-.82 0c-.3.13-.52.53-.97 1.31z"/></svg>`,
};
